<template>
	<my-dialog :visible.sync="showDialog" :title="title" dialog-type="form" :close-on-click-modal="false" @close="closeDialog">
		<div style="width: 60%; margin: 0 auto">
			<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" class="demo-form-inline" align="center" inline>
				<el-form-item label="库存预警数量" prop="warningQuantity">
					<el-input-number v-model="editForm.warningQuantity" class="input_200px" size="small" type="number" :step="1" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="库存常备数量" prop="stockQuantity">
					<el-input-number v-model="editForm.stockQuantity" class="input_200px" size="small" type="number" :step="1" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="存放位置">
					<el-input clearable v-model="editForm.location" class="input_200px" size="small"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import { CreateGoodsWareHouse, GetGoodsWareQuantityConfigDetail, UpdateGoodsWareHouse } from "@/api/storeOrderApi.js";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			saveloading: false,
			editForm: {
				location: "",
				warningQuantity: 0,
				stockQuantity: 0
			},
			goodsKeyIds: [],
			rules: {
				location: [
					{
						required: true,
						message: "请输入存放位置",
						trigger: "blur"
					}
				],
				warningQuantity: [
					{
						required: true,
						message: "请输入库存预警数量",
						trigger: "blur"
					}
				],
				stockQuantity: [
					{
						required: true,
						message: "请输入库存常备数量",

						trigger: "blur"
					}
				]
			},
			isEdit: false,
			title: "生成库存"
		};
	},
	computed: {},
	watch: {},
	components: {},
	created() {},
	methods: {
		// 显示
		showCreateWarehouseDialog(goodsKeyIds, isEdit = false) {
			this.goodsKeyIds = goodsKeyIds;
			this.showDialog = true;
			this.isEdit = isEdit;
			if (this.goodsKeyIds.length == 1) {
				this.GetGoodsWareQuantityConfigDetail();
			}
			if (isEdit) {
				this.title = "修改库存配置";
			} else {
				this.title = "生成库存";
			}
		},
		// 点击保存
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.CreateGoodsWareHouse();
				} else {
					return false;
				}
			});
		},
		// 生成库存
		CreateGoodsWareHouse() {
			this.saveloading = true;
			if (this.isEdit) {
				const params = {
					location: this.editForm.location,
					warningQuantity: this.editForm.warningQuantity,
					stockQuantity: this.editForm.stockQuantity,
					keyIds: this.goodsKeyIds
				};
				UpdateGoodsWareHouse(params)
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "修改成功！"
							});
							this.showDialog = false;
							this.$parent.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.saveloading = false;
						this.$message.error("修改失败，请稍后再试！");
					});
			} else {
				const params = {
					location: this.editForm.location,
					warningQuantity: this.editForm.warningQuantity,
					stockQuantity: this.editForm.stockQuantity,
					keyIds: this.goodsKeyIds
				};
				CreateGoodsWareHouse(params)
					.then((res) => {
						this.saveloading = false;
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "生成成功！"
							});
							this.showDialog = false;
							this.$parent.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.saveloading = false;
						this.$message.error("生成失败，请稍后再试！");
					});
			}
			this.saveloading = false;
		},
		// 获取库存详情
		GetGoodsWareQuantityConfigDetail() {
			this.saveloading = true;
			const params = {
				keyId: this.goodsKeyIds[0]
			};
			GetGoodsWareQuantityConfigDetail(params)
				.then((res) => {
					if (res.code == 1) {
						this.editForm.location = res.data.location;
						this.editForm.warningQuantity = res.data.warningQuantity;
						this.editForm.stockQuantity = res.data.stockQuantity;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("生成失败，请稍后再试！");
				});
			this.saveloading = false;
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
			this.goodsKeyIds = [];
			this.editForm = {
				location: "",
				warningQuantity: 0,
				stockQuantity: 0
			};
			this.saveloading = false;
		}
	}
};
</script>
<style scoped lang="scss">
.up_img {
	width: 100px;
	height: 100px;
	position: relative;

	.ui_delete {
		position: absolute;
		font-size: 20px;
		color: #ff0000;
		top: 0px;
		right: 0px;
	}
}

::v-deep .el-upload--picture-card {
	width: 100px;
	height: 100px;
	line-height: 100px;
}

::v-deep .el-input.is-disabled .el-input__inner {
	background: none;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
	background: none;
}

::v-deep .el-input__inner {
	background: #ffffff;
	color: #606266;
	border: 0.0625rem solid #cfcfcf;
}
</style>
